import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import BottomBannerContent from '@components/StickyBanner/Bottom/Content';
import { AppContextProvider, Env } from '@contexts/AppContext';
import { User } from '@utils/backend-api/currentUser';
import { LeadDetails } from '@utils/backend-api/user';
import { FormLocation } from '@utils/enums';

export interface BottomBannerProps {
  articleId?: number;
  buttonText: string;
  env: Env;
  formLocation: FormLocation;
  headline: string;
  hideUntilScroll: boolean;
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  isLoggedIn: boolean;
  isPro?: boolean;
  isWebview: boolean;
  leadDetails?: LeadDetails;
  leadType?: string;
  submitLink: string;
}

const queryClient = new QueryClient();

// Bottom Banner is not SSR since it depends on the scroll position,
// which needs to be calculated on the client side
const Bottom = ({
  articleId,
  buttonText,
  env,
  formLocation,
  headline,
  hideUntilScroll,
  initialCurrentUser,
  isGdprRequired,
  isLoggedIn,
  isWebview,
  leadDetails,
  leadType,
  submitLink,
}: BottomBannerProps) => {
  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isGdprRequired={isGdprRequired}
      isWebview={isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <BottomBannerContent
          articleId={articleId}
          buttonText={buttonText}
          formLocation={formLocation}
          headline={headline}
          hideUntilScroll={hideUntilScroll}
          isLoggedIn={isLoggedIn}
          leadDetails={leadDetails}
          leadType={leadType}
          submitLink={submitLink}
        />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default Bottom;
